module.exports = __webpack_public_path__ + "static/assets/ed5b6221135fbdb623d4af6a5f65cf2b.png";